import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid } from "@mui/material";
import { withStyles } from "@mui/styles";

import quienesIMG from "../../images/who.jpeg";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const styles = (theme) => ({
  tituloNav: {
    fontWeight: "500",
  },

  cardQuienes: {
    textAlign: "center",
    textDecoration: "none",
    marginLeft: "auto",
    marginRight: "auto",
    placeItems: "center",
    minHeight: "300px",
  },
  corazon: {
    display: "block",
  },

  cardQuienesDos: {
    textAlign: "justify",
    minHeight: "300px",
    paddingLeft: "5%",
    paddingRight: "5%",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px !important",
    },
  },

  boxContainer: {
    backgroundColor: "#fff",
    padding: "50px",
    [theme.breakpoints.down("sm")]: {
      padding: "50px 10px",
    },
  },
});

function Quienes(props) {
  const { width, classes, theme, quienes } = props;
  return (
    <div className={classes.boxContainer} ref={quienes}>
      <div className="container-fluid">
        <Typography variant="h3" align="center" className={classes.tituloNav}>
          Transplog
        </Typography>

        <Grid
          container
          direction="row"
          alignItems="center"
          style={{ marginTop: "50px" }}
        >
          <Grid item md={6} xs={12} className={classes.cardQuienes}>
            <img
              src={quienesIMG}
              alt="¿Quiénes somos?"
              style={{ width: "80%", borderRadius: "1%" }}
            />
          </Grid>
          <Grid item md={6} xs={12} className={classes.cardQuienesDos}>
            <Typography variant="body1" gutterBottom>
              Transplog es un sistema basado en la nube, que te facílita la
              administración de cada operación logística de tu empresa y socios
              comerciales. Permitiéndote conocer en cada momento el estatus de
              tus operaciones y mercancías, así como el costo de las mismas.
            </Typography>
            <Typography variant="body1" sx={{ pt: "20px" }} gutterBottom>
              Buscamos consolidarnos y mantener la confianza total de nuestros
              clientes, por medio de la la competitividad que nos da la
              innovación, capacitación constante, modernidad y calidad de
              nuestros servicios.
            </Typography>

            <Typography variant="h6" sx={{ pt: "20px" }} gutterBottom>
              Benefinicios del sistema
            </Typography>

            <Grid container direction="row" sx={{ pt: "10px" }}>
              <Grid item md={6} xs={12} className={classes.corazon}>
                <AddCircleIcon
                  color="error"
                  fontSize="large"
                  sx={{
                    mr: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Ahorro de tiempo
                </Typography>
              </Grid>
              <Grid item md={6} xs={12} className={classes.corazon}>
                <AddCircleIcon
                  color="error"
                  fontSize="large"
                  sx={{
                    mr: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Optimización de recursos
                </Typography>
              </Grid>
              <Grid item md={6} xs={12} className={classes.corazon}>
                <AddCircleIcon
                  color="error"
                  fontSize="large"
                  sx={{
                    mr: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Disponibilidad
                </Typography>
              </Grid>
              <Grid item md={6} xs={12} className={classes.corazon}>
                <AddCircleIcon
                  color="error"
                  fontSize="large"
                  sx={{
                    mr: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Inteligencia de negocio
                </Typography>
              </Grid>
              <Grid item md={6} xs={12} className={classes.corazon}>
                <AddCircleIcon
                  color="error"
                  fontSize="large"
                  sx={{
                    mr: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Optimización de costos
                </Typography>
              </Grid>
              <Grid item md={6} xs={12} className={classes.corazon}>
                <AddCircleIcon
                  color="error"
                  fontSize="large"
                  sx={{
                    mr: "10px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                />
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ display: "inline-block", verticalAlign: "middle" }}
                >
                  Seguridad
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

Quienes.propTypes = {
  classes: PropTypes.object.isRequired,
  quienes: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(Quienes);
